import React from "react";
import ProductForm from "./productForm";

const EditProduct = (props) => {
 
  return <ProductForm mode="EDIT" userId={props.userId} />;
};

export default EditProduct;
